<template>
    <div class="row">
        <div class="col-sm-12">
            <div class="card">
                <div class="card-body">
                    <div class="table-responsive table-desi table-product">
                        <v-data-table-server
                            class="table table-1d all-package blogGrid"
                            v-model:items-per-page="itemsPerPage"
                            :search="search"
                            :headers="showHeaders"
                            :items-length="pagination.total"
                            :items="dataGrid"
                            :loading="loading"
                            item-value="name"
                            @update:options="getGrid"
                        >
                            <template v-slot:thead>
                                <tbody>
                                    <tr>
                                        <td v-if="selectedHeaders.includes('id')">
                                            <v-text-field v-model="id" hide-details placeholder="Search id..." class="ma-2" density="compact"></v-text-field>
                                        </td>
                                        <td v-if="selectedHeaders.includes('name')">
                                            <v-text-field v-model="name" hide-details placeholder="Search name..." class="ma-2" density="compact"></v-text-field>
                                        </td>
                                        <td v-if="selectedHeaders.includes('description')">
                                            <v-text-field v-model="description" hide-details placeholder="Search description..." class="ma-2" density="compact"></v-text-field>
                                        </td>
                                        <td v-if="selectedHeaders.includes('categoryFather')">
                                            <v-text-field v-model="categoryFather" hide-details placeholder="Search category father..." class="ma-2" density="compact"></v-text-field>
                                        </td>
                                        
                                        <td v-if="selectedHeaders.includes('actions')"></td>
                                    </tr>
                                </tbody>
                            </template>
                            <!-- name/description son JSON {es,en,fr}: mostrar el texto (prioriza ES) en vez del objeto -->
                            <template v-slot:item.name="{ item }">
                                {{ getMultilangText(item.name) }}
                            </template>
                            <template v-slot:item.description="{ item }">
                                {{ formatDescription(item.description) }}
                            </template>
                            <template v-slot:item.actions="{ item }">
                                <v-btn color="primary" class="elevation-0" icon variant="plain" @click="edit(item)"> <v-icon> mdi-pencil-outline </v-icon> </v-btn>
                                <v-btn color="error"   class="elevation-0" icon variant="plain" @click="openDeleteDialog(item)"><v-icon> mdi-trash-can-outline </v-icon> </v-btn>

                                <v-dialog v-model="dialogDelete" max-width="600px">
                                    <v-card>
                                        <v-card-title class="confirmation-dialog" primary-title>Confirmation</v-card-title>
                                        <v-card-text> Are you sure you want to delete the category with the name '{{ getMultilangText(selectedItem.name) }}'? </v-card-text>
                                        <v-card-actions>
                                            <v-btn color="red"   text @click="dialogDelete = false">Cancel</v-btn>
                                            <v-btn color="green" text @click="deleteItem(selectedItem)">Delete</v-btn>
                                        </v-card-actions>
                                    </v-card>
                                </v-dialog>
                            </template>
                        </v-data-table-server>
                        <v-alert v-if="messageError != ''" :type="typeOfMessage" :text="messageError"></v-alert>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { ref, onMounted } from 'vue'
import axios from 'axios'
import { getMultilangText } from '@/services/multilangText'
import { objectExpression } from '@babel/types'

export default {
    title: 'Category',
    props: {},
    data() {
        return {
            dataGrid: ref([]),
            pagination: ref({
                from: 0,
                to: 0,
                total: 0,
                current: 1,
                lastPage: 0
            }),
            itemsPerPage: 10,
            selectedHeaders: ['name', 'description',  'categoryFather','actions'],
            headers: [
                {
                    title: 'ID',
                    align: 'start',
                    sortable: true,
                    key: 'id'
                },
                {
                    title: 'Name',
                    align: 'center',
                    sortable: true,
                    key: 'name'
                },
                {
                    title: 'Description',
                    align: 'center',
                    sortable: true,
                    key: 'description'
                },
                
                {
                    title: 'Category father',
                    align: 'center',
                    sortable: true,
                    key: 'categoryFather'
                },
                {
                    title: 'Actions',
                    align: 'center',
                    sortable: false,
                    key: 'actions'
                }
            ],
            loading: true,

            // Filtros search
            search: '',
            id: '',
            name: '',
            description: '',
            categoryFather: '',

            selectedItem: null,
            dialogDelete: false,
            messageError: '',
            typeOfMessage: ''
        }
    },
    watch: {
        id() {
            this.search = String(Date.now())
        },
        name() {
            this.search = String(Date.now())
        },
        description() {
            this.search = String(Date.now())
        },
        categoryFather() {
            this.search = String(Date.now())
        },
    },
    computed: {
        //Done to get the ordered headers
        showHeaders() {
            return this.headers.filter((s) => this.selectedHeaders.includes(s.key))
        }
    },
    methods: {
        getMultilangText,
        formatDescription(description) {
            if (!description) return ''
            if (typeof description === 'string') return description
            const text = description.es || description.en || description.fr || ''
            return text.length > 80 ? text.slice(0, 80) + '…' : text
        },
        openDeleteDialog(item) {
            this.selectedItem = item;
            this.dialogDelete = true;
        },
        getGrid({ page, itemsPerPage, sortBy, search }) {
            let self = this
            this.loading = true
                                                                                                                
            //Aplicamos los filtros
            let apiURL = process.env.VUE_APP_URL_API_BASE + '/category/grid?page=' + page + '&limit=' + itemsPerPage + '&id=' + self.id;

            if (self.name) {
                apiURL += '&name=' + self.name;
            }

            if (self.description) {
                apiURL += '&description=' + self.description;
            }

            if (self.categoryFather) {
                apiURL += '&category_father=' + self.categoryFather;
            }

            //Aplicamos el orden
            if (sortBy && sortBy[0]) {
                apiURL = apiURL + '&sort=' + sortBy[0].key + '&order=' + sortBy[0].order
            }

            return new Promise(async (resolve, reject) => {
                let status = 'Success'
                await axios({
                    url: apiURL,
                    method: 'GET',
                    data: {},
                    responseType: 'json'
                }).then((response) => {
                    if (response.data) {
                        
                        // Obtenemos la data de dentro de blog guardandola en dataGrid
                        self.dataGrid = []
                        response.data.data.forEach(function (option) {
                            if (option) {
                                self.dataGrid.push(option)
                            }
                        })

                        self.pagination.from = response.data.from
                        self.pagination.to = response.data.to
                        self.pagination.total = response.data.total
                        self.pagination.current = response.data.current_page
                        self.pagination.lastPage = response.data.last_page
                        
                        this.loading = false
                        status = 'Success'
                    }
                })
                resolve(status)
            })
        },
        new(item) {
            this.$router.push({ name: "add_category"});
        },
        edit(item) {
            this.$router.push({ path: "edit_category/" + item.id });
        },
        async deleteItem(item)  {
            let newObject = {
                id: item.id
            }
            await axios.post('http://localhost:8001/admin/category/delete', newObject, {
                responseType: 'json' // Especifica el tipo de respuesta
            }).then((response) => {
                if (response.data.error) {
                    this.messageError = response.data.message
                    this.typeOfMessage = 'error'
                } else {
                    this.messageError = response.data.message
                    this.typeOfMessage = 'success'
                }

                setTimeout(() => (this.messageError = ''), 10000)
            })
            .catch((error) => {
                this.messageError = 'Error! El registro no se ha eliminado.'
                this.typeOfMessage = 'error'
                setTimeout(() => (this.messageError = ''), 10000)
            })

            let paramsGrid = {
                page: this.pagination.current ,
                itemsPerPage: this.itemsPerPage
            }
            await this.getGrid(paramsGrid); 
            this.dialogDelete = false;
        }
    }

    /* async mounted() {
        await this.getGrid()
    }  */
}
</script>

<style></style>
